import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../../app/store';
import { SearchResidentsResponseDto, SearchPropertiesResponseDTO, ResponseType } from '@inosio/payments-sdk';

type SearchResidentState = {
  residentResponse: SearchResidentsResponseDto;
  isSearchingResident: Boolean;
  isSearchingResidentFailed: Boolean;
  isSearchingResidentSucceed: Boolean;
  propertyResponse: SearchPropertiesResponseDTO;
  isSearchingProperty: Boolean;
  isSearchingPropertySucceed: Boolean;
  isSearchingPropertyFailed: Boolean;
  residentErrorResponse: any;
  propertyErrorResponse: any;
};

const getInitialState = () => {
  return {
    residentResponse: {
      ResponseType: ResponseType.Email,
      message: '',
      oneTimeUseToken: '',
      residents: [],
    },
    propertyResponse: { message: '', oneTimeUseToken: '', properties: [] },
    isSearchingResident: false,
    isSearchingResidentFailed: false,
    isSearchingResidentSucceed: false,
    isSearchingProperty: false,
    isSearchingPropertySucceed: false,
    isSearchingPropertyFailed: false,
    residentErrorResponse: {},
    propertyErrorResponse: {},
  } as SearchResidentState;
};

const invitationSlice = createSlice({
  name: 'invitation',
  initialState: getInitialState(),
  reducers: {
    getSearchingResident(state, action) {
      state.isSearchingResident = true;
    },
    setSearchingResident(state, action) {
      const response = {
        residentResponse: action.payload,
        isSearchingResident: false,
        isSearchingResidentFailed: false,
        isSearchingResidentSucceed: true,
      };
      return { ...state, ...response };
    },
    getSearchingResidentFailed(state, action) {
      state.isSearchingResidentFailed = true;
      state.isSearchingResident = false;
      state.residentErrorResponse = action.payload;
      state.isSearchingResidentSucceed = false;
    },
    getSearchingProperty(state, action) {
      state.isSearchingProperty = true;
    },
    setSearchingProperty(state, action) {
      const response = {
        propertyResponse: action.payload,
        isSearchingProperty: false,
        isSearchingPropertyFailed: false,
        isSearchingPropertySucceed: true,
      };
      return { ...state, ...response };
    },
    getSearchingPropertyFailed(state, action) {
      state.isSearchingPropertyFailed = true;
      state.isSearchingProperty = false;
      state.propertyErrorResponse = action.payload;
      state.isSearchingPropertySucceed = false;
    },
    clearSearchingResident(state, action) {
      state.residentResponse = {
        ResponseType: ResponseType.Email,
        message: '',
        residents: [],
      };
      state.isSearchingResident = false;
      state.isSearchingResidentFailed = false;
      state.isSearchingResidentSucceed = false;
      state.residentErrorResponse = {};
    },
    clearSearchingProperty(state, action) {
      state.propertyResponse = { message: '', oneTimeUseToken: '', properties: [] };
      state.isSearchingProperty = false;
      state.isSearchingPropertySucceed = false;
      state.isSearchingPropertyFailed = false;
      state.propertyErrorResponse = {};
    },
    clearSearchingState(state, action) {
      state.isSearchingResident = false;
      state.isSearchingResidentFailed = false;
      state.isSearchingResidentSucceed = false;
      state.residentErrorResponse = {};
      state.isSearchingProperty = false;
      state.isSearchingPropertySucceed = false;
      state.isSearchingPropertyFailed = false;
      state.propertyErrorResponse = {};
    },
  },
});

export const {
  getSearchingResident,
  setSearchingResident,
  getSearchingResidentFailed,
  getSearchingProperty,
  setSearchingProperty,
  getSearchingPropertyFailed,
  clearSearchingResident,
  clearSearchingProperty,
  clearSearchingState,
} = invitationSlice.actions;

export default invitationSlice.reducer;
export const selectResidentResponse = (state: RootState) => state.invitation.residentResponse;
export const selectPropertyResponse = (state: RootState) => state.invitation.propertyResponse;
export const selectInvitationState = (state: RootState) => state.invitation;
